<template>
    <v-container>
        <v-card class="pa-4">
            <v-card-title>
                <div class="d-flex align-center">
                    <v-btn icon @click="goBack" class="mr-2">
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-chip color="info" text-color="white" small>
                        История изменений
                    </v-chip>
                </div>
            </v-card-title>

            <v-card-text>
                <div class="mb-4" v-if="itemInfo">
                    <v-chip color="primary" small class="mr-2">
                        ID: {{ itemInfo.id }}
                    </v-chip>
                    <v-chip color="primary" small class="mr-2">
                        Количество: {{ itemInfo.qty }}
                    </v-chip>
                    <v-chip color="primary" small>
                        Дата: {{ formatDate(itemInfo.date) }}
                    </v-chip>
                </div>

                <v-timeline dense>
                    <v-timeline-item
                        v-for="(event, index) in history"
                        :key="index"
                        :color="getEventColor(event)"
                        small
                    >
                        <template v-slot:icon>
                            <v-icon :color="getEventColor(event)">
                                {{ getEventIcon(event) }}
                            </v-icon>
                        </template>
                        <template v-slot:opposite>
                            <span class="caption">
                                {{ formatDateTime(event.timestamp) }}
                            </span>
                        </template>
                        <div>
                            <strong>{{ event.user }}</strong>
                            <span class="ml-2">{{ event.description }}</span>
                            <div v-if="event.changes" class="mt-1">
                                <v-chip
                                    v-for="(change, key) in event.changes"
                                    :key="key"
                                    small
                                    class="mr-1"
                                    :color="getChangeColor(change)"
                                >
                                    {{ key }}: {{ change.old }} → {{ change.new }}
                                </v-chip>
                            </div>
                        </div>
                    </v-timeline-item>
                </v-timeline>

                <div v-if="!history.length" class="text-center pa-4">
                    <v-icon size="48" color="grey lighten-1">mdi-clock-outline</v-icon>
                    <div class="mt-2 grey--text">История изменений отсутствует</div>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: 'BillingChangeHistory',

    data() {
        return {
            loading: false,
            itemInfo: null,
            history: []
        };
    },

    async created() {
        await this.loadHistory();
    },

    methods: {
        async loadHistory() {
            this.loading = true;
            try {
                const id = this.$route.params.id;
                
                // Получаем информацию об изменении
                const itemResponse = await this.axios.get(`/BillingChanges/${id}`);
                if (itemResponse.data) {
                    this.itemInfo = itemResponse.data;
                }

                // Получаем историю изменений (если есть отдельный эндпоинт)
                try {
                    const historyResponse = await this.axios.get(`/BillingChanges/${id}/history`);
                    if (historyResponse.data && Array.isArray(historyResponse.data)) {
                        this.history = historyResponse.data;
                    }
                } catch (error) {
                    // Если нет отдельного эндпоинта для истории, показываем заглушку
                    this.history = [];
                }

                // Если история пустая, добавляем заглушку
                if (!this.history.length && this.itemInfo) {
                    this.history = [{
                        user: 'Система',
                        timestamp: this.itemInfo.date,
                        description: 'Запись создана',
                        changes: null
                    }];
                }
            } catch (error) {
                console.error('Error loading history:', error);
                this.showError('Не удалось загрузить историю изменений');
            } finally {
                this.loading = false;
            }
        },

        formatDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return dateString;
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}.${month}.${year}`;
        },

        formatDateTime(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return dateString;
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${day}.${month}.${year} ${hours}:${minutes}`;
        },

        getEventColor(event) {
            if (event.type === 'delete') return 'red';
            if (event.type === 'update') return 'orange';
            if (event.type === 'create') return 'green';
            return 'grey';
        },

        getEventIcon(event) {
            if (event.type === 'delete') return 'mdi-delete';
            if (event.type === 'update') return 'mdi-pencil';
            if (event.type === 'create') return 'mdi-plus';
            return 'mdi-information';
        },

        getChangeColor(change) {
            if (change.type === 'increase') return 'success';
            if (change.type === 'decrease') return 'error';
            return 'info';
        },

        goBack() {
            this.$router.push({ name: 'BillingChangesList' });
        },

        showError(message) {
            if (this.$toast?.error) {
                this.$toast.error(message);
            } else {
                console.error('Error:', message);
            }
        }
    }
};
</script>

<style scoped>
.v-timeline-item :deep(.v-timeline-item__body) {
    background: #f5f5f5;
    padding: 12px;
    border-radius: 4px;
}
</style>